<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="80px"
    >
      <el-form-item label="PMS类型" prop="pmsType">
        <el-select
          :model-value="queryParams.pmsType as any"
          @update:model-value="(val: any) => queryParams.pmsType = val"
          class="!w-240px"
          clearable
          placeholder="请选择PMS类型"
        >
          <el-option label="绿云" value="绿云" />
          <el-option label="西软" value="西软" />
          <el-option label="Opera" value="Opera" />
        </el-select>
      </el-form-item>
      <el-form-item label="同步类型" prop="syncType">
        <el-input
          v-model="queryParams.syncType"
          class="!w-240px"
          clearable
          placeholder="请输入同步类型"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="同步状态" prop="syncStatus">
        <el-select
          :model-value="queryParams.syncStatus as any"
          @update:model-value="(val: any) => queryParams.syncStatus = val"
          class="!w-240px"
          clearable
          placeholder="请选择同步状态"
        >
          <el-option label="成功" :value="0" />
          <el-option label="失败" :value="1" />
          <el-option label="冲突" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="PMS类型" prop="pmsType" width="120">
        <template #default="scope">
          <el-tag type="info">{{ getPmsTypeLabel(scope.row.pmsType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="同步类型" prop="syncType" width="120">
        <template #default="scope">
          <el-tag>{{ getSyncTypeLabel(scope.row.syncType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="同步方向" prop="syncDirection" width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.syncDirection === 0" type="primary">推送</el-tag>
          <el-tag v-else-if="scope.row.syncDirection === 1" type="success">拉取</el-tag>
          <span v-else>{{ scope.row.syncDirection }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="同步状态" prop="syncStatus" width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.syncStatus === 0" type="success">成功</el-tag>
          <el-tag v-else-if="scope.row.syncStatus === 1" type="danger">失败</el-tag>
          <el-tag v-else-if="scope.row.syncStatus === 2" type="warning">冲突</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="耗时" prop="duration" width="100">
        <template #default="scope">
          <span v-if="scope.row.duration">{{ scope.row.duration }}ms</span>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="错误信息" prop="errorMsg" min-width="150" />
      <el-table-column align="center" label="备注" prop="remark" min-width="150" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as pmsApi from '@/api/hotel/pms'

defineOptions({ name: 'HotelPms' })

const message = useMessage()

const loading = ref(true)
const total = ref(0)
const list = ref([])

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  pmsType: undefined,
  syncType: undefined,
  syncStatus: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await pmsApi.getPmsPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

// PMS 类型映射
const pmsTypeMap: Record<string, string> = {
  'OPERA': 'Opera', 'XIRUAN': '西软', 'LVYUN': '绿云', 'STONE': '石基',
  'MINGSIGN': '明软', 'JINJIANG': '锦江', 'HUATU': '华住'
}
const getPmsTypeLabel = (t: string) => pmsTypeMap[t] || t || '-'

// 同步类型映射
const syncTypeMap: Record<string, string> = {
  'ROOM': '房型', 'PRICE': '价格', 'INVENTORY': '库存', 'ORDER': '订单',
  'GUEST': '客人', 'PAYMENT': '支付', 'FULL': '全量'
}
const getSyncTypeLabel = (t: string) => syncTypeMap[t] || t || '-'

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

onMounted(() => {
  getList()
})
</script>
